import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/*
 * Lightweight SEO helper, no react-helmet dependency. Every public page renders
 * <SEO title="..." description="..." /> at the top of its component. On mount and
 * whenever inputs change, we update <title>, <meta name="description">, canonical
 * link, and Open Graph / Twitter card tags in the document head.
 *
 * Canonical origin is locked to https://holytrinitykileleshwa.org (no www).
 */
const ORIGIN = "https://holytrinitykileleshwa.org";
const DEFAULT_IMG = ORIGIN + "/images/logo.png";

function setMeta(key, content, attr = "name") {
    if (!content) return;
    const sel = `meta[${attr}="${key}"]`;
    let el = document.head.querySelector(sel);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(href) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", href);
}

const SEO = ({ title, description, image = DEFAULT_IMG, type = "website" }) => {
    const { pathname } = useLocation();
    useEffect(() => {
        const url = ORIGIN + pathname;
        const fullTitle = title
            ? `${title} | Holy Trinity Catholic Church, Kileleshwa`
            : "Holy Trinity Catholic Church, Kileleshwa, Archdiocese of Nairobi";
        document.title = fullTitle;
        setMeta("description", description);
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", description, "property");
        setMeta("og:image", image, "property");
        setMeta("og:url", url, "property");
        setMeta("og:type", type, "property");
        setMeta("og:site_name", "Holy Trinity Catholic Church, Kileleshwa", "property");
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", fullTitle);
        setMeta("twitter:description", description);
        setMeta("twitter:image", image);
        setCanonical(url);
    }, [title, description, image, type, pathname]);
    return null;
};

export default SEO;
